import React from "react";
import { Link } from "react-router-dom";
import { ICooperativeDetails } from "../../exports/interfaces";
import { Eye } from "lucide-react";

const DocumentsInfo = ({
  cooperative,
}: {
  cooperative: ICooperativeDetails | null;
}) => {
  return (
    <>
      <h6 className="primary-color">Documents</h6>
      <div className="dashboard-card mt-3">
        <div className="table-responsive admin-table table-checkbox">
          <table className="table align-middle">
            <tbody>
              <tr>
                <td>Registration Certificate</td>
                <td className="sticky-action">
                  <div className="d-flex gap-3 align-items-center justify-content-end">
                    <Link
                      to={`${process.env.REACT_APP_Url}${cooperative?.documents?.regCertificateUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View"
                      >
                        <Eye />
                      </i>
                    </Link>
                  </div>
                </td>
              </tr>
              <tr>
                <td>By Law Document</td>
                <td className="sticky-action">
                  <div className="d-flex gap-3 align-items-center justify-content-end">
                    <Link
                      to={`${process.env.REACT_APP_Url}${cooperative?.documents?.lawDocumentUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View"
                      >
                        <Eye />
                      </i>
                    </Link>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Founding Document</td>
                <td className="sticky-action">
                  <div className="d-flex gap-3 align-items-center justify-content-end">
                    <Link
                      to={`${process.env.REACT_APP_Url}${cooperative?.documents?.foundingDocumentUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View"
                      >
                        <Eye />
                      </i>
                    </Link>
                  </div>
                </td>
              </tr>
              <tr>
                <td>PAN Registration Document</td>
                <td className="sticky-action">
                  <div className="d-flex gap-3 align-items-center justify-content-end">
                    <Link
                      to={`${process.env.REACT_APP_Url}${cooperative?.documents?.foundingDocumentUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View"
                      >
                        <Eye />
                      </i>
                    </Link>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Business Registration Document</td>
                <td className="sticky-action">
                  <div className="d-flex gap-3 align-items-center justify-content-end">
                    <Link
                      to={`${process.env.REACT_APP_Url}${cooperative?.documents?.foundingDocumentUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View"
                      >
                        <Eye />
                      </i>
                    </Link>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Tax Clearance Document</td>
                <td className="sticky-action">
                  <div className="d-flex gap-3 align-items-center justify-content-end">
                    <Link
                      to={`${process.env.REACT_APP_Url}${cooperative?.documents?.foundingDocumentUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View"
                      >
                        <Eye />
                      </i>
                    </Link>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Board Meeting Minutes</td>
                <td className="sticky-action">
                  <div className="d-flex gap-3 align-items-center justify-content-end">
                    <Link
                      to={`${process.env.REACT_APP_Url}${cooperative?.documents?.meetingDocumentUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View"
                      >
                        <Eye />
                      </i>
                    </Link>
                  </div>
                </td>
              </tr>
              <tr>
                <td>General Meeting Minutes</td>
                <td className="sticky-action">
                  <div className="d-flex gap-3 align-items-center justify-content-end">
                    <Link
                      to={`${process.env.REACT_APP_Url}${cooperative?.documents?.meetingDocumentUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View"
                      >
                        <Eye />
                      </i>
                    </Link>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Other Supporting Document</td>
                <td className="sticky-action">
                  <div className="d-flex gap-3 align-items-center justify-content-end">
                    <Link
                      to={`${process.env.REACT_APP_Url}${cooperative?.documents?.otherDocumentUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View"
                      >
                        <Eye />
                      </i>
                    </Link>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr />
    </>
  );
};

export default DocumentsInfo;
